import * as React from 'react';
import FlatfyLogo from '../flatfy-logo/FlatfyLogo';

import styles from './Header.module.scss';
import ContentContainer from '../content-container/ContentContainer';
import NavigationBurger from '../navigation-burger/NavigationBurger';
import { AnalyticsConsumer } from '../../providers/AnalyticsProvider';

const Header = ({ theme, isNavigationOpened, onNavigationOpen, onNavigationClose }) => (
  <header className={styles.base}>
    <ContentContainer width="wide">
      <div className={styles.layout}>
        <a className={styles.logo} href="/" aria-current="page">
          <FlatfyLogo theme={theme} />
        </a>
        <div className={styles.navigationToggle}>
          <AnalyticsConsumer category="menu">
            {({ sendAction, dataProps }) => (
              <NavigationBurger
                theme={theme}
                pressed={isNavigationOpened}
                onClick={() => {
                  if (isNavigationOpened) {
                    onNavigationClose();
                    sendAction('close');
                  } else {
                    onNavigationOpen();
                    sendAction('open');
                  }
                }}
                {...dataProps}
              />
            )}
          </AnalyticsConsumer>
        </div>
      </div>
    </ContentContainer>
  </header>
);

export default Header;
